<template>
  <div class="bg-gray-100 flex justify-center h-screen w-screen">
    <div class="m-auto w-1/2 bg-white rounded-lg shadow rounded p-8">
      <p class="mb-2 text-xl">Login</p>
      <form @submit.prevent="onLogin">
        <div class="flex flex-col w-full">
          <input type="email" class="mb-2" placeholder="example@mail.com" v-model="email" />
          <input type="password" placeholder="password" v-model="password" />
          <p class="text-red-600 text-xs" v-if="error">{{error}}</p>
        </div>
        <div class="py-2 text-right">
          <button
            type="submit"
            class="p-1 px-4 bg-indigo-600 text-white rounded p-1 outline-none"
          >Login</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from "vuex";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      email: "",
      password: "",
      error: null
    };
  },
  methods: {
    ...mapActions(["login"]),
    async onLogin() {
      this.error = null;
      try {
        const user = await this.login({
          email: this.email,
          password: this.password
        });
        // console.log(user);
        // this.$router.push("home");
      } catch (error) {
        this.error = error.message;
      }
    }
  }
};
</script>
